import fetchRedux from "../../api/fetch_redux";
import { toast } from "react-toastify";
import { setAguardar } from ".";
import { ToastErro } from "../../utils/utils";

export const CADASTRO_MENSAGENS_GET_MENSAGENS =
  "CADASTRO_MENSAGENS_GET_MENSAGENS";
export const CADASTRO_MENSAGENS_UPD_MENSAGEM =
  "CADASTRO_MENSAGENS_UPD_MENSAGEM";
//
const ROTAS = ["/cadastro_mensagens"];
//
export const cadastroMensagensGetMensagens = () => (dispatch) => {
  fetchRedux(
    ROTAS[0],
    "POST",
    null,
    (resp) => {
      // Tudo certo, vamos atualizar os dados
      dispatch({
        type: CADASTRO_MENSAGENS_GET_MENSAGENS,
        data: resp,
      });
    },
    () => {},
    (err) => {
      ToastErro(err);
    }
  );
};
// Action para atualizar uma mensagem
export const cadastroMensagensUpdMensagem = (obj) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[0],
    "PUT",
    obj,
    (resp) => {
      toast(resp.sucesso);
      // Tudo certo vamos atualizar os dados
      dispatch({
        type: CADASTRO_MENSAGENS_UPD_MENSAGEM,
        data: resp.data,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => ToastErro(err)
  );
};
